<div class="container site-map">
    <div class="row justify-content-start">
        <div class="col-md-6 offset-3 justify-content-start">
            <div class="root-node">
                <a [routerLink]="['/home']" aria-label="Home Page">Home Page</a>
            </div>
            <div
                class="line-vertical"
                [ngStyle]="{
                    '--line-left': '36.9%',
                    '--line-top': '120px',
                    '--line-height': user ? '2165px' : '1510px',
                    '--line-color': '#D9534F'
                }"></div>
            <!-- Vertical line -->
        </div>
    </div>

    <!-- Row for All Auctions and Sub-nodes -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <!-- Horizontal line for All Auctions -->
                <div class="node">
                    <a [routerLink]="['/auctions']" aria-label="Auctions Page"
                        >All Auctions</a
                    >
                </div>
            </div>
            <div
                class="line-vertical"
                style="
                    --line-left: 40%;
                    --line-top: 75%;
                    --line-height: 174px;
                    --line-color: #707070;
                "></div>
            <!-- Vertical line -->
        </div>
    </div>

    <!-- Sub-nodes for Auctions -->
    <div class="row">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node" style="--sub-node-margin-top: 15px">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Live Auctions Page"
                        >Live Auctions</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Upcoming Auctions Page"
                        >Upcoming Auctions</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Closed Auctions Page"
                        >Closed Auctions</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for About Us -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a [routerLink]="['/about-us']" aria-label="About Us Page"
                        >About Us</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Contact Us -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a
                        [routerLink]="['/contact-us']"
                        aria-label="Contact Us Page"
                        >Contact Us</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Categories and Sub-nodes -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a [routerLink]="['/auctions']" aria-label="Categories Page"
                        >Categories</a
                    >
                </div>
            </div>
            <div
                class="line-vertical"
                style="
                    --line-left: 40%;
                    --line-top: 75%;
                    --line-height: 428px;
                    --line-color: #707070;
                "></div>
            <!-- Vertical line -->
        </div>
    </div>
    <div class="row">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Vehical Category Page"
                        >Vehicles</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Antiques Category Page"
                        >Antiques</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Tools Category Page"
                        >Tools</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Real Estate Category Page"
                        >Real Estate</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Collectibles Category Page"
                        >Collectibles</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Jewelry Category Page"
                        >Jewelry</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/auctions']"
                        aria-label="Electronics Category Page"
                        >Electronics</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Featured Auctions and Sub-nodes -->
    <div class="row">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a
                        [routerLink]="['/home']"
                        aria-label="Featured Auctions Page"
                        >Featured Auctions</a
                    >
                </div>
                <div
                    class="line-vertical"
                    style="
                        --line-left: 40%;
                        --line-top: 75%;
                        --line-height: 110px;
                        --line-color: #707070;
                    "></div>
                <!-- Vertical line -->
            </div>
        </div>
    </div>
    <div class="row justify-content-start">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/home']"
                        aria-label="Current Featured Page"
                        >Current Featured</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/home']"
                        aria-label="Upcoming Featured Page"
                        >Upcoming Featured</a
                    >
                </div>
            </div>
        </div>
    </div>
    <!-- Row for User Profile and Sub-nodes for Not loggedIn -->

    <div class="row justify-content-start" *ngIf="!user">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a
                        [routerLink]="['/login']"
                        aria-label="Register OR Sign In Page"
                        >Register/Sign In</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for User Profile and Sub-nodes -->
    <div class="row justify-content-start" *ngIf="user">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a
                        [routerLink]="['/profiles']"
                        aria-label="User Profile Page"
                        >User Profile</a
                    >
                </div>
                <div
                    class="line-vertical"
                    style="
                        --line-left: 40%;
                        --line-top: 75%;
                        --line-height: 492px;
                        --line-color: #707070;
                    "></div>
                <!-- Vertical line -->
            </div>
        </div>
    </div>
    <div class="row justify-content-start" *ngIf="user">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profiles/my-profile/']"
                        aria-label="User Dashboard Page"
                        >Dashboard</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profile/my-profile']"
                        aria-label="User Information Page"
                        >Information</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profiles/my-profile/my-addresses']"
                        aria-label="User Addresses Page"
                        >Addresses</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profiles/my-profile/my-invoices']"
                        aria-label="User Invoices Page"
                        >My Invoices</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profiles/my-profile/my-bidding']"
                        aria-label="User bidding History Page"
                        >My Bid History</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/profile/payment-info']"
                        aria-label="Payment Information Page"
                        >Payment Information</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Watchlist -->
    <div class="row justify-content-start" *ngIf="user">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a
                        [routerLink]="['/profiles/watchlist']"
                        aria-label="Watchlist Page"
                        >Watchlist</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Messages -->
    <div class="row justify-content-start" *ngIf="user">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a [routerLink]="['/messages']" aria-label="Messages Page"
                        >Messages</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Help and Sub-nodes -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a [routerLink]="['/help']" aria-label="Help Page">Help</a>
                </div>
            </div>
            <div
                class="line-vertical"
                style="
                    --line-left: 40%;
                    --line-top: 75%;
                    --line-height: 237px;
                    --line-color: #707070;
                "></div>
            <!-- Vertical line -->
        </div>
    </div>
    <div class="row justify-content-start">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a [routerLink]="['/help/faq']" aria-label="Help FAQ Page"
                        >FAQ</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/help/shipping']"
                        aria-label="Help Shipping Information Page"
                        >Shipping Information</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/help/payment-options']"
                        aria-label="Help Payment Options Page"
                        >Payment Options</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/help/return-policy']"
                        aria-label="Return Policy Page"
                        >Return Policy</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Row for Legal and Sub-nodes -->
    <div class="row justify-content-start">
        <div class="offset-4 col-4 node-container">
            <div class="sub-node-line-container">
                <div
                    class="line-horizontal"
                    style="
                        --line-width: 80px;
                        --line-left: 30%;
                        --line-top: 50%;
                        --line-color: #d9534f;
                    "></div>
                <div class="node">
                    <a [routerLink]="['/legal']" aria-label="Legal Page"
                        >Legal</a
                    >
                </div>
            </div>
            <div
                class="line-vertical"
                style="
                    --line-left: 40%;
                    --line-top: 75%;
                    --line-height: 174px;
                    --line-color: #707070;
                "></div>
            <!-- Vertical line -->
        </div>
    </div>
    <div class="row justify-content-start">
        <div class="offset-5 col-4 px-0">
            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/terms-and-conditions']"
                        aria-label="Terms and Conditions Page"
                        >T&Cs</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/privacy-policy']"
                        aria-label="Privacy Policy Page"
                        >Privacy Policy</a
                    >
                </div>
            </div>

            <div class="sub-node-line-container" style="--padding-left: 68px">
                <div
                    class="line-horizontal"
                    style="--line-width: 50px; --line-color: #707070"></div>
                <!-- Horizontal line -->
                <div class="sub-node">
                    <a
                        [routerLink]="['/legal/cookies']"
                        aria-label="Cookies Policy Page"
                        >Cookies Policy</a
                    >
                </div>
            </div>
        </div>
    </div>
</div>
